export default{
    namespaced: true,

    state:{
        fecha:null,
        turnosColores:{
            mat:'#81D4FA',
            ves:'#A5D6A7',
            noc:'#EF9A9A',
        },
        turnosNombre:{
            mat:'Matutino',
            ves:'Vespertino',
            noc:'Nocturno',
        },
        horarios:{
            mat: [
                '08:00', '09:00', '10:00', '11:00', '12:00', '13:00', '14:00',
            ],
            ves: [
                '15:00', '16:00', '17:00', '18:00', '19:00', '20:00',
            ],
            noc: [
                '21:00', '22:00', '23:00', '00:00', '01:00', '02:00', '03:00', '04:00', '05:00', '06:00', '07:00',
            ],
        },
        horariosMedias:{
            mat: [
                '08:00', '08:30', '09:00', '09:30', '10:00', '10:30',
                '11:00', '11:30', '12:00', '12:30', '13:00', '13:30', '14:00', '14:30'
            ],
            ves: [
                '15:00', '15:30', '16:00', '16:30', '17:00', '17:30',
                '18:00', '18:30', '19:00', '19:30', '20:00', '20:30',
            ],
            noc: [
                '21:00', '21:30', '22:00', '02:30', '23:00', '23:30', '00:00', '00:30', '01:00', '01:30',
                '02:00', '02:30', '03:00', '03:30', '04:00', '04:30', '05:00', '05:30', '06:00', '06:30','07:00', '07:30',
            ],
        },

        signosList:[
            {signo: 'temp',min: 33,max: 43,nombreLargo:'Temperatura (ºC)'},
            {signo: 'fc',min: 20,max: 220,nombreLargo:"Frec. cardiaca (X')"},
            {signo: 'fr',min: 5,max: 220,nombreLargo:"Frec. resp. (X')"},
            {signo: 'peso',min: 0,max: 400,nombreLargo:"Peso (Kg)"},
            {signo: 'talla',min: 10,max: 250,nombreLargo:"Talla (cm)"},
            {signo: 'ta',min: 0,max: 100,nombreLargo:"T. Artetial (mmHg)"},
            {signo: 'tam',min: 0,max: 250,nombreLargo:"T. Artetial MEDIA(mmHg)"},
            {signo: 'sat',min: 0,max: 100,nombreLargo:'Saturación (%)'},
            {signo: 'glic',min: 0,max: 1000,nombreLargo:'Glicemia (ml/dl)'},
        ],

        tiposSoluciones:[
            {value:1, text:"Solución (base)"},
            {value:7, text:"Solución (NaCl"},
            {value:8, text:"Solución (Glucosa)"},
            {value:9, text:"Solución (Dialisis 1.5)"},
            {value:2, text:"N.T.P."},
            {value:3, text:"Electrolitos"},
            {value:4, text:"Carga"},
            {value:5, text:"Hemocomponentes (paquetas)"},
            {value:10, text:"Hemocomponentes (eritrocitos)"},
            {value:6, text:"Infusión"},
            {value:99, text:"Otros"},
        ],

    },
    mutations:{
        CAMBIA_FECHA(state, data){
            state.fecha = data
        },


    },
    actions:{
        /**
         * Carga datos generales del internamiento
         */
        async cargaDatosInternamiento(context, internamiento){
            try{
                const req = await this.$http({
                    url: context.rootState.http.hospital.datosIner,
                    method:'GET',
                    params:{internamiento:internamiento}
                })
                return({estado:true, root:req.data.root})
            } catch(err){
                return ({estado:false, err:err})
            }
        },
        /**
         * Carga datos generales del paciente
         */
        async cargaDatosPaciente(context, paciente){
            try{
                const req = await this.$http({
                    url: context.rootState.http.pacientes.list2,
                    method:'GET',
                    params:{id:paciente}
                })
                return({estado:true, root:req.data})
            } catch(err){
                return ({estado:false, err:err})
            }
        },
        /**
         * Lista escalas
         */
        async carga_escalas(context, data){
            try{
                const req = await this.$http({
                    url:context.rootState.http.enfermeria.listEscalas,
                    method:'GET',
                    params:{internamiento:data.internamiento, fecha:data.estaFecha},
                })
                return({estado:true, root:req.data})
            }catch(err){
                return ({estado:false, err:err})
            }

        },
        /**
         * Carga datos de historia clínica
         */
        async carga_hc(context, data){
            try{

                let req = await this.$http({
                    url: context.rootState.http.hc.list,
                    method:'POST',
                    params:{paciente:data},
                })

                return({estado:true, root:req.data.root})
            }catch(err){
                return ({estado:false, err:err})
            }
        },
        /**
         * Lista escalas
         */
        async carga_liquidos(context, data){
            try{
                const req = await this.$http({
                    url:context.rootState.http.enfermeria.listInEg,
                    method:'GET',
                    params:{internamiento:data.internamiento, fecha:data.estaFecha},
                })
                return({estado:true, root:req.data})
            }catch(err){
                return ({estado:false, err:err})
            }

        },
        /**
         * Lista notas
         */
        async carga_notas(context, data){
            try{
                const req = await this.$http({
                    url:context.rootState.http.notas.list,
                    method:'GET',
                    params:{
                        internamiento:data.internamiento,
                        fecha:data.estaFecha,
                        tipoNota:12,
                    },
                })
                return({estado:true, root:req.data.root})
            }catch(err){
                return ({estado:false, err:err})
            }

        },
        /**
         * Lista somato
         */
        async carga_somato(context, data){
            try{
                const req = await this.$http({
                    url:context.rootState.http.enfermeria.cargaSignos,
                    method:'GET',
                    params:{internamiento:data.internamiento, fecha:data.estaFecha},
                })
                return({estado:true, root:req.data})
            }catch(err){
                return ({estado:false, err:err})
            }

        },
        /**
         * Lista valoración inicial
         */
        async carga_valinicial(context, data){
            try{
                const req = await this.$http({
                    url:context.rootState.http.enfermeria.listValInicial,
                    method:'GET',
                    params:{internamiento:data.internamiento, fecha:data.estaFecha},
                })
                return({estado:true, root:req.data})
            }catch(err){
                return ({estado:false, err:err})
            }

        },
        /**
         * Lista Medicamentos
         */
        async carga_meds(context, data){
            try{
                const req = await this.$http({
                    url:context.rootState.http.enfermeria.listMedicamentos,
                    method:'GET',
                    params:{internamiento:data.internamiento, fecha:data.estaFecha},
                })
                return({estado:true, root:req.data.root})
            }catch(err){
                return ({estado:false, err:err})
            }

        },
        /**
         * Lista Procedimientos y asistenciales
         */
        async carga_procs(context, data){
            try{
                const req = await this.$http({
                    url:context.rootState.http.enfermeria.listProcs,
                    method:'GET',
                    params:{internamiento:data.internamiento, fecha:data.estaFecha},
                })
                return({estado:true, root:req.data})
            }catch(err){
                return ({estado:false, err:err})
            }

        },
        /**
         * Lista Procedimientos y asistenciales
         */
        async carga_val_ini(context, data){
            try{
                const req = await this.$http({
                    url:context.rootState.http.enfermeria.listValInicial,
                    method:'GET',
                    params:{internamiento:data.internamiento},
                })
                return({estado:true, root:req.data})
            }catch(err){
                return ({estado:false, err:err})
            }

        },
    },
    getters:{
        //
    },
}